var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E3E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8873_4935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8873_4935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 24C9.45 24 8.97933 23.8043 8.588 23.413C8.196 23.021 8 22.55 8 22V19H10V22H22V19H24V22C24 22.55 23.8043 23.021 23.413 23.413C23.021 23.8043 22.55 24 22 24H10ZM15 20V11.85L12.4 14.45L11 13L16 8L21 13L19.6 14.45L17 11.85V20H15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableUpload);
export default __webpack_public_path__ + "static/media/DisableUpload.77639378e6cf52d3c0747b3781a5871f.svg";
export { ForwardRef as ReactComponent };